import React, { useState } from 'react';
import OptionsList from './OptionsList';  // The updated OptionsList component
import RagURLs from './RagURLs';
import QASection from './QASection';

const RAG = () => {
  // Default selected option is 'qa' (Q&A)
  const [selectedOption, setSelectedOption] = useState('qa');

  // Handle selection changes
  const handleSelectOption = (ref) => {
    setSelectedOption(ref);
  };

  return (
    <div className="flex h-screen bg-gray-20">
      {/* Sidebar with Options List */}
      <div className="sticky top-0 w-64 h-screen bg-gray-100 p-4 border-r overflow-y-auto"> 
        <OptionsList
          selectedOption={selectedOption}
          onSelectOption={handleSelectOption}
        />
      </div>

      {/* Main Area */}
      <div className="flex-grow flex flex-col">
        {/* Render dynamic content based on selectedOption */}
        <div className="flex-grow flex justify-center items-center p-6">
          <div className="w-full max-w-4xl h-full mt-20 flex flex-col items-center">
            {selectedOption === 'qa' && (
              <div className='w-full'>
                <h1 className="text-2xl font-bold">Q&A Section</h1>
                <QASection/>
              </div>
            )}
            {selectedOption === 'urls' && (
              <div className='w-full'>
                <h1 className="text-2xl font-bold">URLs Section</h1>
                <RagURLs/>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RAG;
